export const DASHBOARD_PLUGIN_KEYS = [
  'current-expenses',
  'current-incomes',
  'income-expense-chart',
  'months-left',
  'income-expense-table',
  'currency-pairs',
  'bot-monitor',
  'history-index',
  'day-trade-monitor',
] as const

export type DashboardPluginKey = (typeof DASHBOARD_PLUGIN_KEYS)[number]
